/* eslint-disable no-undef */
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:8080/root/api';
export const LOADING_DELAY = 300;